import { Box, Tooltip, Typography } from '@mui/material';
import * as React from 'react';

import { displayLabelStyles, tooltipItemStyles } from './DepartmentFilter.styles';

interface IDisplayLabelProps {
  selectedDepartments: string[];
  label: string;
}

export const DisplayLabel: React.FC<IDisplayLabelProps> = ({ selectedDepartments, label }) => {
  if (selectedDepartments.length === 0) {
    return <>{label}</>;
  }

  const displayText = selectedDepartments.join(', ');
  const tooltipContent = (
    <Box>
      {selectedDepartments.map((name, index) => (
        <Box key={index} sx={tooltipItemStyles}>
          • {name}
        </Box>
      ))}
    </Box>
  );

  return (
    <Tooltip title={tooltipContent} arrow placement="bottom-start">
      <Typography sx={displayLabelStyles}>{displayText}</Typography>
    </Tooltip>
  );
};
